import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class ConsistencyTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (ConsistencyTypeModel._instance == null) ConsistencyTypeModel._instance = new ConsistencyTypeModel(authManager);
        return ConsistencyTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/consistency-types', 'geo-sections/consistency-types/codelist');

        this.entityName = 'geo-sections.ConsistencyType';
        this.privileges = {
            create: [["adminSystem"]],
            read: [["#everyone"]],
            update: [["adminSystem"]],
            delete: [["adminSystem"]],
        };

        this.label = 'Consistency Type';
        this.setLabel = 'Consistency Types';

        this.browser = {
            name: 'default-geo-sections-consistencytype-browser',
            moduleName: 'default-geo-sections-consistencytype-browser',
            moduleTitle: 'Consistency Types',
            moduleStateSlotName: 'default-geo-sections-consistencytype-browser',
        };

        this.editor = {
            name: 'default-geo-sections-consistencytype-editor',
            moduleName: 'default-geo-sections-consistencytype-editor',
            moduleTitle: 'Consistency Type',
            moduleStateSlotName: 'default-geo-sections-consistencytype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
            {
                name: 'codeStandardDocumentId',
                type: 'CodeStandardDocument',
                persistent: true,
                label: 'Code Standard Document',
            },
            {
                name: 'notesEn',
                type: 'string',
                persistent: true,
                label: 'Notes En',
            },
            {
                name: 'notesCz',
                type: 'string',
                persistent: true,
                label: 'Notes Cz',
            },
        ];

    }

}
